import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import axios from "axios";
import VueAxios from "vue-axios";

const actualidad = {
  state: {
    noticias: "",
  },
  getters: {
    categoriaNoticias: (state) => {
      let noticias = state.noticias;

      if (!!noticias) {
        let categorias = new Array();

        noticias.forEach((noticia) => {
          if (!categorias.some((c) => c.slug == noticia.categories[0].slug)) {
            categorias.push(noticia.categories[0]);
          }
        });
        console.log(categorias);
        return categorias;
      }
    },
    getNoticiasFiltradas: (state) => {
      return (filtro) => {
        let searchIn = ["titulo", "entradilla"];

        let noticias = state.noticias;

        let filtradas;

        if (!!noticias) {
          filtradas = noticias.filter((noticia) => {
            let can = false;

            searchIn.forEach((where) => {
              noticia[where].toLowerCase().includes(filtro.search.toLowerCase())
                ? (can = true)
                : "";
            });

            return can ? noticia : "";
          });

          filtradas = filtradas.filter((noticia) =>
            noticia.categoria.slug.includes(filtro.categoria),
          );
        }

        return filtradas;
      };
    },
    getNoticias: (state) => {
      return state.noticias;
    },
  },
  actions: {
    requestNoticias: ({ commit }) => {
      let data = {
        columns: [
          {
            name: "categories",
            onlyWith: true,
          },
        ],
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`api/entries/paginate`, data)
          .then((response) => {
            commit("setNoticias", response.data.data);
            resolve(true);
          })
          .catch((error) => reject(error));
      });
    },
    requestNoticia: ({ commit }, slug) => {
      let data = {
        columns: [
          {
            name: "categories",
            onlyWith: true,
          },
        ],
        filters: [
          {
            name: "slug",
            search: slug,
          },
        ],
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/entries/paginate`, data)
          .then((response) => {
            resolve(response.data.data[0]);
          })
          .catch((err) => reject(err));
      });
    },
  },
  mutations: {
    setNoticias: (state, noticias) => {
      state.noticias = noticias;
    },
  },
};

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/noticias.js